import { CurrencyCode } from '@/finance/interfaces';

import { DISLOYALTY_MEMBERSHIP_PRICES } from '../disloyalty-membership-prices.const';

export function getDisloyaltyMembershipPrice(currency: CurrencyCode) {
  return DISLOYALTY_MEMBERSHIP_PRICES.find(
    (price) => price.currencyCode === currency
  );
}
